'use strict';

module.exports = {
    NO_GOOGLE_PAY_BRAINTREE_CONFIGURATIONS: 'No Google Pay Braintree Configurations',
    ORDER_TOTAL_0: 'Order total 0 is not allowed for GooglePay',
    GOOGLE_PAY_WINDOW_CLOSED: 'User closed the Payment Request UI.'
};
